import type { GetDearProductsResponse } from "@api/getDearProducts";
import { getDearProducts } from "@api/getDearProducts";
import { useQuery } from "@tanstack/react-query";

export const useGetDearProducts = (productCategories: string[], currency: string = "usd") =>
  useQuery<GetDearProductsResponse, Error>({
    queryKey: ["dear-products", productCategories, currency],
    queryFn: () => getDearProducts({ productCategories, currency }),
    enabled: productCategories.length > 0,
  });
